import * as IconParkIcons from '@icon-park/react';

const parseIconJson = (value) => {
  if (typeof value !== 'string') return null;
  const trimmed = value.trim();
  if (!trimmed.startsWith('{') && !trimmed.startsWith('[') && !trimmed.startsWith('"')) {
    return null;
  }
  try {
    const parsed = JSON.parse(trimmed);
    if (typeof parsed === 'string') {
      try {
        return JSON.parse(parsed);
      } catch {
        return null;
      }
    }
    if (Array.isArray(parsed)) {
      return parsed[0] && typeof parsed[0] === 'object' ? parsed[0] : null;
    }
    return parsed && typeof parsed === 'object' ? parsed : null;
  } catch {
    return null;
  }
};

// Helper function to render icons consistently across the application
export const renderIcon = (icon, size = 24, className = "me-2") => {
  
  if (!icon || icon === null || icon === undefined || icon === "null") return null;

  const normalizedIcon = parseIconJson(icon) || icon;

  if (typeof normalizedIcon === 'string') {
    // Legacy support for old emoji strings
    return <span className={className}>{normalizedIcon}</span>;
  }
  
  if (normalizedIcon.type === 'emoji') {
    return <span className={className}>{normalizedIcon.value}</span>;
  }
  
  if (normalizedIcon.type === 'iconpark') {
    const IconComponent = IconParkIcons[normalizedIcon.value];
    if (IconComponent) {
      return <IconComponent theme={normalizedIcon.theme} size={size} fill={normalizedIcon.fill} className={className} />;
    }
  }
  
  if (normalizedIcon.type === 'brand') {
    return (
      <svg width={size} height={size} viewBox="0 0 24 24" fill={`#${normalizedIcon.hex}`} className={className}>
        <path d={normalizedIcon.path} />
      </svg>
    );
  }
  
  return null;
};
